import { render, staticRenderFns } from "./filterItems.vue?vue&type=template&id=5161b698&scoped=true"
import script from "./filterItems.vue?vue&type=script&lang=js"
export * from "./filterItems.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161b698",
  null
  
)

export default component.exports